import * as React from 'react';
import { Tooltip } from '@cian/ui-kit';

import * as styles from './PromoItem.css';
import { IPromo } from '../../../../types/newbuilding/promos';

interface IPromoItemProps {
  onClick?(promo: IPromo): void;
  onHover?(promo: IPromo): void;
  promo: IPromo;
  icon: string;
}

export function PromoItem({ promo, onClick, onHover, icon }: IPromoItemProps) {
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(promo);
    }
  }, [promo, onClick]);

  const handleMouseEnter = React.useCallback(() => {
    if (onHover) {
      onHover(promo);
    }
  }, [promo, onHover]);

  return (
    <div className={styles['container']}>
      <Tooltip title={promo.name} placement="top" arrow>
        <div className={styles['logo']} onClick={handleClick} onMouseEnter={handleMouseEnter}>
          <img src={icon} alt={promo.name} />
        </div>
      </Tooltip>
    </div>
  );
}
